import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';
import {CareService} from '../../../../types/CareService';
import {CareproviderContactInfo} from '../../../../types/CareproviderContactInfo';
import {CareproviderUnitType} from '../../../../types/CareproviderUnitType';
import {ToolsService} from '../../../../services/tools.service';
import {TimeslotDetails} from '../../../../types/TimeslotDetails';
import {BookingTypeIdEnum} from '../../../../enums/BookingEnums';
import {CareproviderUnitService} from '../../../../services/careprovider-unit.service';
import {EventActionEnum, EventCategoryEnum} from '../../../../enums/GaTrackingEnums';
import {BookingSettings} from '../../../../types/BookingSettings';
import {DataLayerParamsClickGA4} from '../../../../types/DataLayerParamsClickGA4';

@Component({
  selector: 'app-care-service-book',
  templateUrl: './care-service-book.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'care-service-book block rounded-lg border border-duck-blue-2 bg-white px-4 py-5',
  },
})
export class CareServiceBookComponent {
  public logoUrl = input<string>(null);
  public careProviderUnitId = input<number>(null);
  public careProviderUnitName = input<string>(null);
  public careProviderUnitUrl = input<string[]>(null);
  public careProviderContactInfo = input<CareproviderContactInfo>(null);
  public mainCaregiverUnitType = input<CareproviderUnitType>(null);
  public bookingSettings = input<BookingSettings[]>(null);
  public careService = input<CareService>(null);
  protected pageType: DLPageTypeEnum = DLPageTypeEnum.CARE_PROVIDER_PAGE;
  protected readonly dLPageTypeEnum = DLPageTypeEnum;
  protected readonly eventCategoryEnum = EventCategoryEnum;
  protected readonly eventActionEnum = EventActionEnum;
  private tools = inject(ToolsService);
  protected displayBookingBtn = computed(
    () =>
      this.careService() &&
      !this.tools.isNil(this.careService().bookingConfigurationData) &&
      this.careService().bookingConfigurationData.length > 0,
  );
  private careProviderUnitService = inject(CareproviderUnitService);
  protected careServicesTimeSlots = computed<[TimeslotDetails, TimeslotDetails?] | null>(() => {
    if (
      this.careService().timeSlots == undefined ||
      this.careService().timeSlots.length == 0 ||
      this.careService().careServiceBookingSettings.bookingType.id !== BookingTypeIdEnum.VARDEN
    ) {
      return null;
    }
    const timeslots: [TimeslotDetails, TimeslotDetails?] = [
      this.careProviderUnitService.genTimeslotDetails(
        this.careService().id,
        this.careService().timeSlots[0],
        this.careProviderUnitId(),
      ),
    ];
    if (this.careService().timeSlots.length > 1) {
      timeslots.push(
        this.careProviderUnitService.genTimeslotDetails(
          this.careService().id,
          this.careService().timeSlots[1],
          this.careProviderUnitId(),
        ),
      );
    }
    return timeslots;
  });
  protected isInternal = computed<boolean>(() =>
    this.careProviderUnitService.isInternalCareService(this.careService(), this.bookingSettings()),
  );
  protected dataLayerParams = computed<DataLayerParamsClickGA4>(() =>
    this.careProviderUnitService.getDataLayerEventParams(
      this.careService(),
      0,
      this.careProviderUnitId(),
      this.mainCaregiverUnitType()?.id,
      this.mainCaregiverUnitType()?.area?.id,
      this.pageType,
    ),
  );
}
